module.exports = __webpack_public_path__ + "img/appltCourse-img16.f4b08253.png";